import Head from "next/head";
import { useRouter } from "next/router";
import useSWR from "swr";
import Throw404 from "components/throw404";
import Card from "components/global/card";
import Breadcrumb from "components/global/breadcrumbs";

import COMPANY_QUERY from "queries/company";

export default function CompanyDetails() {
  const router = useRouter();

  const variables = {
    slug: router.query.company,
  };

  const { data, error } = useSWR([COMPANY_QUERY, variables]);

  if (error) {
    console.log(error);
  }

  if (!Array.isArray(data?.companies) || !data?.companies?.length) {
    return <Throw404 />;
  }

  const company = data.companies[0];

  const breadcrumbs = [];

  breadcrumbs.push({
    name: company.Name,
    link: "/company/[company]",
    linkAs: `/company/${company.Slug}`,
  });

  return (
    <>
      <Head>
        <title>{company.Name} | Open Coaster</title>
      </Head>
      <main className="container m-6 mx-auto px-6 sm:px-0">
        <Breadcrumb items={breadcrumbs} />
        <h2 className="mb-10 font-serif text-5xl text-gray-800">
          {company.Name}
        </h2>

        {Array.isArray(company.Resorts) && company.Resorts.length > 0 && (
          <>
            <h3 className="mb-3 font-serif text-3xl text-gray-800">
              {company.Resorts.length > 1 ? "Resorts" : "Resort"}
            </h3>
            <div className="mb-10 grid grid-cols-2 gap-8 md:grid-cols-2 lg:grid-cols-4">
              {company.Resorts.map((resort) => (
                <Card
                  link={`/resort/${resort.Slug}`}
                  title={resort.Name}
                  image={resort.MainPhoto}
                  type="resort"
                  key={resort.id}
                />
              ))}
            </div>
          </>
        )}

        {Array.isArray(company.Parks) && company.Parks.length > 0 && (
          <>
            <h3 className="mb-3 font-serif text-3xl text-gray-800">
              {company.Parks.length > 1 ? "Parks" : "Park"}
            </h3>
            <div className="grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4">
              {company.Parks.map((park) => (
                <Card
                  link={`/park/${park.Slug}`}
                  title={park.Name}
                  image={park.MainPhoto}
                  type="park"
                  isTempClosed={park.IsTempClosed}
                  key={park.id}
                />
              ))}
            </div>
          </>
        )}
      </main>
    </>
  );
}
